export default __webpack_public_path__ + "static/media/goiCuocHeadViettel.80cbd376.svg";